import { accountRoutes } from './routes';
import makeRoutes from 'utils/make-routes';
import React from 'react';
import { Switch } from 'react-router-dom';
import BannersContext from 'features/shared/Banners/BannersContext';
import SurveyAboutReportsInCabmun from 'features/shared/Onbording/SurveyAboutReportsInCabmun';

const AuthApp = () => {
  return (
    <BannersContext>
      <Switch>{makeRoutes(accountRoutes)}</Switch>
      <SurveyAboutReportsInCabmun />
    </BannersContext>
  );
};

export default AuthApp;
